<template>
  <div class="addendum-box">
    <div
      v-for="(tab, index) in addendums"
      :key="index"
      class="addendum-item"
    >
      <label class="tab-label">{{ tab.title }}</label>
      <div
        v-for="field in tab.fieldDiffs"
        :key="field.title"
        class="line-content"
      >
        <div
          v-if="field.diffMatchPatchResult"
          class="diff-match-patch-panel"
        >
          <span class="emphasize-content">{{ actionNameOf(field.action) }}</span>
          <span class="inline-content">{{ field.title }}</span>
          <pre
            class="diff-row"
            v-html="field.diffMatchPatchResult"
          />
        </div>
        <template v-else>
          <div
            v-if="field.oldValue"
            class="previous-panel"
          >
            <span class="emphasize-content">{{ actionDict.PREVIOUS }}</span>
            <span class="inline-content">{{ field.title }}</span>
            <pre
              class="diff-row field-value"
              v-html="field.oldValue"
            />
          </div>
          <div class="update-panel">
            <span class="emphasize-content">{{ actionNameOf(field.action) }}</span>
            <span :class="{ 'removed-content': field.action === 'D', 'inline-content': field.value}">{{ field.title }}</span>
            <pre
              class="field-value"
              :class="{ 'removed-content': field.action === 'D' }"
              v-html="field.value"
            />
          </div>
        </template>
      </div>
    </div>
    <div v-if="!addendums || !(addendums.length > 0)">
      <div class="previous-panel">
        <span>{{ $t('hint.noContent') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { actionDict } from '@/utils/locale'

export default {
  name: 'AddendumItem',
  props: {
    addendums: {
      type: Array,
      default () {
        return []
      },
    },
  },
  computed: {
    actionDict () {
      return actionDict
    },
  },
  methods: {
    actionNameOf (actionCode) {
      return actionDict[actionCode] || 'Updated'
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-label {
  font-family: Verdana;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #0C3A58;
  &:after {
    content: ':'
  }
}

.diff-row {
  color: #0C3A58;
  text-align: left;
}

.line-content {
  font-family: Verdana;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #e69500;
  .field-value {
    & ::v-deep p {
      font-weight: normal;
      margin-bottom: 0;
    }
    & ::v-deep .flex{
      display: inline-flex;
      align-content: flex-start;
    }
  }
}

.emphasize-content {
  font-weight: bold;
  &:before {
    content: '['
  }
  &:after {
    content: ']'
  }
  margin: 9px 0 9px 0;
}

.inline-content {
  &:after {
    content: ':'
  }
}

.previous-panel {
  color: #a3a3a3;
  pre {
    color: #a3a3a3;
  }
}

.update-panel {
  padding-bottom: 10px;
}

.removed-content {
  text-decoration: line-through;
}
</style>
